export default function AdminPartnersIdPage() {
	return <div>123</div>;
}
